import React, { useState } from 'react';
import { Form, InputGroup, Table, Button } from 'react-bootstrap';
import { IoMdAdd, IoMdSync } from 'react-icons/io';
import { IoCreateOutline, IoTrashOutline } from 'react-icons/io5';
import { ThreeDots } from 'react-loader-spinner';

function AdditionalCharges({ unitMeasure, additionalChargesData, setAdditionalChargesData }) {

  const [isAdding, setIsAdding] = useState(false);
  const [data, setData] = useState({
    index: null,
    name: '',
    amount: '',
    type: 'only'
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(e) {
    const { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  function handleType(e) {
    setData((prevData) => {
      return { ...prevData, type: e.target.value };
    });
  }

  function handleData() {
    if (data && data.name && data.amount) {
      if (data && data.index !== null) {
        let tempData = additionalChargesData;
        tempData[data.index].type = data.type;
        tempData[data.index].name = data.name;
        tempData[data.index].amount = data.amount;
        setData({ ...data, index: null, name: '', amount: '' });
      } else {
        let tempData = additionalChargesData;
        tempData.push({ type: data.type, name: data.name, amount: data.amount });
        setData({ ...data, index: null, name: '', amount: '' });
        setAdditionalChargesData(tempData);
      }
    } else {
      if (data && !data.name) {
        setInputError({ ...inputError, name: 'This field is required.' });
      } else if (data && !data.amount) {
        setInputError({ ...inputError, amount: 'This field is required.' });
      }
    }
  }

  function handleDeleteData(index) {
    let tempData = additionalChargesData;
    tempData.splice(index, 1);
    setAdditionalChargesData(tempData);
    setData({ index: null, type: 'per', name: '', amount: '' });
  }

  return (
    <>
      {
        additionalChargesData && additionalChargesData.length > 0 ?
          <div className='p-3'>
            <Table bordered className='bg-light'>
              <tbody>
                {
                  additionalChargesData.length > 0 && additionalChargesData.map((item, index) => {
                    return (
                      <tr key={index} className={data && data.index === index ? 'bg-warning' : ''}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>₹{item.amount}{item.type === 'per' ? '/' + unitMeasure : ''}</td>
                        {
                          data && data.index !== null && data.index === index ?
                            <td className='d-flex align-items-center justify-content-center'>
                              <ThreeDots
                                width='26'
                                height='26'
                                color={`var(--bs-dark)`}
                              />
                            </td>
                            :
                            <td className='d-flex align-items-center justify-content-center'>
                              <Button
                                variant='none'
                                size='sm'
                                className='p-1 text-primary border-0 rounded px-2'
                                onClick={() => setData({ index: index, type: item.type, name: item.name, amount: item.amount })}
                              >
                                <IoCreateOutline size={18} />
                              </Button>
                              <Button
                                variant='none'
                                size='sm'
                                className='p-1 text-danger border-0 rounded px-2'
                                onClick={() => handleDeleteData(index)}
                              >
                                <IoTrashOutline size={18} />
                              </Button>
                            </td>
                        }
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
          :
          null
      }
      {
        isAdding || additionalChargesData ?
          <div className='row p-3'>
            <div className='col-md-5 col-12'>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name (Additional Charge)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter charge name"
                  className={inputError && inputError.name ? 'border-danger' : null}
                  onChange={handleChange}
                  value={data.name}
                  isInvalid={inputError && inputError.name}
                />
                <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-md-5 col-12'>
              <div className='d-flex justify-content-between'>
                <Form.Group className="mb-3 w-100 m" controlId="amount">
                  <Form.Label>Amount</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>₹</InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Enter amount"
                      className={inputError && inputError.amount ? 'border-left-0 border-right-0 border-danger' : 'border-left-0 border-right-0'}
                      onChange={handleChange}
                      value={data.amount}
                      isInvalid={inputError && inputError.amount}
                    />
                    <Form.Select
                      className='border-left-0 bg-primary-light'
                      align="end"
                      onChange={handleType}
                      value={data.type}
                    >
                      <option value={'per'}>per {unitMeasure}</option>
                      <option value={'only'}>Only</option>
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <div className='col-md-2 col-12'>
              <Form.Label></Form.Label>
              {
                data && data.index !== null ?
                  <Button
                    variant='warning'
                    onClick={handleData}
                    className='py-2 mt-2 w-100'
                    size='sm'
                  >
                    <IoMdSync size={20} />
                    <div className='ms-1'>Update</div>
                  </Button>
                  :
                  <Button
                    variant='success'
                    onClick={handleData}
                    className='py-2 mt-2 w-100'
                    size='sm'
                  >
                    <IoMdAdd size={20} />
                    <div className='ms-1'>Add</div>
                  </Button>
              }
            </div>
          </div>
          :
          <div className='d-block p-3'>
            <Button
              variant='outline-primary'
              className='text-center border-dashed rounded-3 shadow-none w-100 py-4'
              onClick={() => setIsAdding(true)}
            >
              <div>
                <IoMdAdd size={32} />
                <h5 className='fw-normal mt-3'>Add Additional Charges</h5>
              </div>
            </Button>
          </div>
      }
    </>
  );
}

export default AdditionalCharges;
